module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-600.7f1c3fed.woff2";